module.exports = __webpack_public_path__ + "img/底边栏-二维码.f0de46a3.jpg";